import { cn } from '@/lib/utils';
import { UNDERWRITING_STATUS_CONFIG, type UnderwritingStatus } from '@shared';

interface UnderwritingStatusBadgeProps {
  status: UnderwritingStatus;
  className?: string;
  onViewDetails?: () => void;
}

export function UnderwritingStatusBadge({
  status,
  className,
  onViewDetails,
}: UnderwritingStatusBadgeProps) {
  if (!status) return null;

  const config = UNDERWRITING_STATUS_CONFIG[status];
  if (!config) return null;

  const isInteractive = !!onViewDetails;

  if (isInteractive) {
    return (
      <button
        type="button"
        onClick={onViewDetails}
        className={cn(
          'inline-flex w-28 items-center justify-center rounded-full border px-2 py-1 text-xs font-medium transition-all duration-200',
          'focus:ring-primary hover:opacity-80 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-1',
          'cursor-pointer',
          config.classes.bgColor,
          config.classes.textColor,
          config.classes.borderColor,
          className,
        )}
        aria-label={`View ${config.label} details`}
        data-testid="quote-detail-eligibility-status"
      >
        {config.label}
      </button>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex w-28 items-center justify-center rounded-full border px-2 py-1 text-xs font-medium',
        config.classes.bgColor,
        config.classes.textColor,
        config.classes.borderColor,
        className,
      )}
      data-testid="quote-detail-eligibility-status"
    >
      {config.label}
    </span>
  );
}
